<template>
    <div>

        <div v-if="!isAuthenticated" class="password-overlay">
            <div class="password-modal">
                <h4 class="mb-3">🔒 Enter Password to View Purchase Summary</h4>
                <input 
                    type="password" 
                    v-model="enteredPassword" 
                    @keyup.enter="verifyPassword"
                    class="form-control mb-3" 
                    placeholder="Password"
                />
                <button 
                    @click="verifyPassword" 
                    class="btn btn-primary btn-block custom-explore"
                >
                    Access Report
                </button>
                <p v-if="authError" class="text-danger mt-2">{{ authError }}</p>
            </div>
        </div>

        <div v-if="isLoading" class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <p class="mt-3 text-muted">Fetching product report data...</p>
        </div>


        <div v-if="!isLoading && isAuthenticated">

    
            <h3 class="header-title">Purchase Summary</h3>
            <label>Let’s see your billing account payment.</label>
         
             
              <CCol sm="12" class="p-0">
                <CRow>
                  <CCol sm="12">
                    <CCard class="box-shadow-dashboard">
                    
                      <br />
                      <div class="d-flex justify-content-between align-items-center mb-2 px-2">
          <h6><strong>Transaction Information</strong></h6>
          <CButton color="primary" @click="downloadCSV" class="custom-explore">
            <i class="cil-cloud-download"></i> Download Transaction
          </CButton>
        </div>
                      <div class="mb-3 p-2">
          <input
            v-model="searchText"
            type="text"
            class="form-control"
            placeholder="Search by name, title, phone,date or status..."
          />
        </div>
        <div class="table-responsive">
          <table class="table">
            <thead style="position: sticky; top: 0; background-color: white; z-index: 2; border-bottom: 2px solid #dee2e6;">
                                                    <th></th>
                                                    <th class="text-muted">Product</th>
                                                    <th class="text-muted">Date Purchase</th>
                                                    <th class="text-muted">Ref Number</th>
                                                    <th class="text-muted">Price</th>
                                                    <th class="text-muted">Status</th>
                                                    <th>Whatsapp</th>
                                                    <th>Action</th>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="item in filteredBill" :key="item.Id">
                                                        <td>
                                                            <img :src="item.PicturePath" alt="Course Image" style="max-width: 70px; object-fit: cover;border-radius:5px">
                                                            {{ item.SubscribeProductId }}
                                                        
                                                        </td>
                                                        <td>
                                                          <h3 class="custom-16px-600 m-0">
                                                                {{ item.Name }} <br /> <br />
                                                               <span class="text-muted"> {{ item.Email }}  ({{ item.Phone }})</span> <br /> <br />
                                                               <span class="text-muted small" v-if="item.CodeAffiliate != null"> Agent:<strong class="ml-1">{{ item.AffiliateName }}({{ item.CodeAffiliate }})</strong></span>
                                                            </h3>
                                                            <br /> 
                                                            <label class="text-muted m-0 mt-1">
                                                                {{ item.Title }}- <label class="text-muted">Quantity: </label> x{{ item.Quantity }}
                                </label>
                                <br />
                                <div v-if="item.ListSubjectLoose.length > 0">
                                    <strong class="mt-5">
                                                              Loose Subject:
                                                            </strong>
                                    <ul v-for="sub in item.ListSubjectLoose" v-bind:key="sub.Id" class="mt-3">
                                        <li>{{ sub.CourseName }}</li>
                                    </ul>
                                </div>
        
        
                                <br />
        
        
                                </td>
                                <td>
                                    <label class="text-muted m-0 mt-1">
                                                                {{ item.CreatedTime | moment("DD/MM/YYYY HH:mm:ss") }}
                                                            </label>
                                </td>
                                <td>
                                    <label class="text-muted m-0 mt-1">
                                                                {{ item.BillPlizId }}
                                                            </label>
                                </td>
                                <td>
                                    <h3 class="custom-16px-600 m-0 mt-1 d-flex">
                                        <span>RM</span> <span class="ml-1">{{ item.AmountPaid }}</span>
                                    </h3>
                                </td>
                                <td>
                                    <div class="custom-badge-success" v-if="item.Status === 'Completed'">
                                        {{ item.Status }}
                                    </div>
                                    <div class="custom-badge-danger" v-else>
                                        {{ item.Status }}
                                    </div>
        
                                </td>
                                <td>
                                    <a v-if="item.Phone" :href="`https://wa.me/${item.Phone.replace(/[^0-9]/g, '').startsWith('6') ? '' : '6'}${item.Phone.replace(/[^0-9]/g, '')}`" target="_blank" class="custom-badge-success bg-white">
                                                            <img src="../../assets/img/whatsapp.jpeg" width="20px" />
                                                              WhatsApp
                                                            </a>
                                </td>
                                <td>
                                    <CButton class="custom-explore btn-primary m-2" @click="OpenAssign(item)"><img src="../../assets/img/assign.png" width="20px" /></CButton>
                                    <CButton class="custom-border-danger m-2" @click="OpenDelete(item)"><img src="../../assets/img/trash.png" width="20px" /></CButton>
                                </td>
                                </tr>
                                </tbody>
                                </table>
                            </div>
                            </CCard>
                        </CCol>
        
                    </CRow>
                    </CCol>
                    <CModal title="Delete Purchase" size="md" :show.sync="showDeleteModal">
                        <div class="text-center">
                            <img src="../../assets/img/deletevector.png" style="max-width:70%" class="mb-2" />
                            <br />Are you sure you want to delete the purchase made by <b><strong>{{ userNamePurchase }}</strong></b> for <strong><b>{{ packageName }}</b></strong>?
        
                        </div>
                        <template #footer>
                                    <CButton class="p-2 mr-2" color="secondary" @click="showDeleteModal = false">Cancel</CButton>
                                    <CButton class="p-2" color="danger" @click="deleteItem(deleteItemId)">Delete</CButton>
                        </template>
                    </CModal>


                    <CModal title="Assign Agent" size="md" :show.sync="showAssignModal">
                        <div class="text-left mb-5">
                           
                            <br />Assign agent code in the purchase made by <b><strong>{{ userNamePurchase }}</strong></b> for <strong><b>{{ packageName }}</b></strong>?
                            <br />   <br />
                            <v-select
                  v-model="selectedAgent"
                  :options="agentOptions"
                  label="label"
                  columnFilter
                ></v-select>
                        </div>
                        <template #footer>
                                    <CButton class="p-2 mr-2" color="secondary" @click="showAssignModal = false">Cancel</CButton>
                                    <CButton class="p-2" color="danger" @click="assignItem(assignItemId)">Assign</CButton>
                        </template>
                    </CModal>
        </div>
    </div>
  </template>
  
  
<script>
import Vue from "vue";
import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
import backgroundUrl from "../../assets/img/bgCard.png";

import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css"; // import styles

Vue.use(VuejsDialog);


import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartBar } from "@coreui/vue-chartjs";
import VueEllipseProgress from "vue-ellipse-progress";

//import "@fullcalendar/core/vdom"; // solves problem with Vite]

import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";
import VueHtmlToPaper from "vue-html-to-paper";
const options = {
    name: "_blank",
    specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
    styles: [
        "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
        "https://unpkg.com/kidlat-css/css/kidlat.css",
        "../assets/css/pagebreak.css",
    ],
};
Vue.use(VueHtmlToPaper, options);

Vue.use(FullCalendar);
Vue.use(VueEllipseProgress);

// Define the required password here
const ACCESS_PASSWORD = "Flyhigh192077**";


export default {
    name: "Collapses",
    components: {
        PulseLoader,
        CChartBar,
        Calendar,
    },
    data() {
        return {
            // --- AUTHENTICATION DATA ---
            isAuthenticated: false,
            enteredPassword: '',
            authError: '',
            // ---------------------------

            backgroundUrl,
            user: {},

            currentDate: new Date().toISOString().substring(0, 10),

            check: {},
            bill: {},
            searchText: "",

            showDeleteModal: false,
            deleteItemId: 0,
            packageName: '', // Added for delete modal
            userNamePurchase: '', // Added for delete modal

            isLoading: false,
            showAssignModal: false,
            agentOptions: []
        };
    },
    async mounted() {
        // --- AUTHENTICATION CHECK ---
        // 1. Check if the user is generally authenticated (UserAuth)
       
        let savedAuth = localStorage.getItem("affiliateReportAuth");

if (savedAuth === "true") {
    this.isAuthenticated = true;
    this.SessionUserIdNo();
    this.GetListAgent();
   
            
    return;
}

// Still need login check for app
let isAuth = await this.UserAuth();
if (!isAuth) this.GoToLogin();
    },
    computed: {
        filteredBill() {
                if (!this.searchText) return this.bill;

                const keyword = this.searchText.toLowerCase();

                return this.bill.filter(item => {
                const createdDate = item.CreatedTime
                    ? this.$options.filters.moment(item.CreatedTime, "DD/MM/YYYY HH:mm:ss").toLowerCase()
                    : "";

                return (
                    (item.Name && item.Name.toLowerCase().includes(keyword)) ||
                    (item.Title && item.Title.toLowerCase().includes(keyword)) ||
                    (item.Status && item.Status.toLowerCase().includes(keyword)) ||
                    (item.Phone && item.Phone.toLowerCase().includes(keyword)) ||
                    (item.BillPlizId && item.BillPlizId.toLowerCase().includes(keyword)) ||
                    createdDate.includes(keyword)
                );
                });
            }
    },
    methods: {
        // --- NEW METHOD: PASSWORD CHECK ---
       
        verifyPassword() {
            this.authError = '';

            if (this.enteredPassword === ACCESS_PASSWORD) {
                this.isAuthenticated = true;
                this.enteredPassword = '';

                // 🔥 Save auth state so refresh won't require re-entering password
                localStorage.setItem("affiliateReportAuth", "true");
                this.SessionUserIdNo(); 

            } else {
                this.authError = 'Incorrect password. Please try again.';
            }
        },

        // ----------------------------------

        SessionUserIdNo() {
            if (!this.isAuthenticated) return; // Prevent API call if not authenticated
            return this.$API
                .get(this.$LoginUserDetailAdmin, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.user = response.data;
                        this.GetCheckTc(this.user.tuitioncenter);
                        this.GetListBilling(this.user.userAccountId); // Now calls GetListBilling
                    }
                });
        },
        GetCheckTc(tuitioncenter) {
            if (!this.isAuthenticated) return; // Prevent API call if not authenticated
            return this.$API
                .get(this.$GetCheckTcPackage + "?TuitionCenterId=" + tuitioncenter, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.check = response.data;
                    }
                });
        },
        GetListBilling() {
            if (!this.isAuthenticated) return; // Prevent API call if not authenticated
            this.isLoading = true;
            return this.$API
                .get(
                    this.$GetListPaymentProduct, {
                        withCredentials: true,
                    }
                )
                .then((response) => {
                    if (response.status == 200) {
                        this.isLoading = false;
                        this.bill = response.data;
                    }
                });
        },
        GoToRenew() {
            window.open("https://www.pickiddo.com/RenewPackage?UserGroupId=" + this.user.usergroupId, "_blank");
        },
        async SubmitExisting() {
            // ... (Your existing SubmitExisting logic remains the same, assuming it's part of the authenticated context)
        },
        OpenDelete(item) {
            if (item) {
                this.deleteItemId = Number(item.SubscribeProductId); // normalize id
                this.packageName = item.Title;
                this.userNamePurchase = item.Name;
                this.showDeleteModal = true;
            }
        },
        deleteItem(id) {
            const formData = new FormData();
            formData.append("SubscribeProductId", id);

            return this.$API
                .post(this.$RemovePurchase, formData, { withCredentials: true })
                .then((response) => {
                    if (response.status == 200) {
                        this.GetListBilling();
                        this.showDeleteModal = false;
                        this.$dialog.alert("Purchase deleted successfully.");
                        this.items = this.items.filter(item => item.id !== id);

                    } else {
                        console.log("Error Deleting");
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        OpenAssign(item) {
            if (item) {
                this.assignItemId = Number(item.SubscribeProductId); // normalize id
                this.packageName = item.Title;
                this.userNamePurchase = item.Name;
                this.showAssignModal = true;
            }
        },
        assignItem(id) {
            const formData = new FormData();
            formData.append("subscribeProductId", id);
            formData.append("agentCode", this.selectedAgent.CodeAff);

            return this.$API
                .post(this.$UpdateAssignAgent, formData, { withCredentials: true })
                .then((response) => {
                    if (response.status == 200) {
                        this.GetListBilling();
                        this.showAssignModal = false;
                        this.$dialog.alert("Purchase assign successfully.");
                        this.items = this.items.filter(item => item.id !== id);

                    } else {
                        console.log("Error Deleting");
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        GetListAgent() {
            if (!this.isAuthenticated) return; // Prevent API call if not authenticated
            return this.$API
                .get(
                    this.$GetListAffiliate, {
                        withCredentials: true,
                    }
                )
                .then((response) => {
                    if (response.status == 200) {
                        this.agentOptions = response.data.map(a => ({
                    ...a,
                    label: `${a.Name} (${a.CodeAff})`   // <-- combine parameters here
                }));
                    }
                });
        },
        downloadCSV() {
            if (!this.filteredBill || this.filteredBill.length === 0) {
                alert("No data to download");
                return;
            }

            // Define CSV headers
            const headers = [
                "Customer Name",
                "Product / Package",
                "Quantity",
                "Date",
                "Ref Number",
                "Price (RM)",
                "Status",
                "Phone",
                "Agent Name",
                "Loose Subjects",
            ];

            // Map data to rows (include Loose Subjects)
            const rows = this.filteredBill.map(item => {
                // Product name (main purchased product)
                const productName = item.Title || item.Name || "";

                // Quantity
                const quantity = item.Quantity || 1;

                // Loose subjects (optional)
                let looseSubjects = "";
                if (item.ListSubjectLoose && item.ListSubjectLoose.length > 0) {
                    looseSubjects = item.ListSubjectLoose
                        .map(sub => sub.CourseName)
                        .join(" | ");
                }

                const agentName = item.AffiliateName
                    ? `${item.AffiliateName} (${item.CodeAffiliate})`
                    : "";

                return [
                    `"${item.Name || ""}"`,
                    `"${productName}"`,
                    `"${quantity}"`,
                    `"${this.$options.filters.moment(item.CreatedTime, "DD/MM/YYYY")}"`,
                    `"${item.BillPlizId || ""}"`,
                    `"${item.AmountPaid || ""}"`,
                    `"${item.Status || ""}"`,
                    `"${item.Phone || ""}"`,
                    `"${agentName}"`,
                    `"${looseSubjects}"`
                ];
            });

            // Combine into CSV format
            const csvContent = [headers.join(","), ...rows.map(r => r.join(","))].join("\n");

            // Create downloadable CSV
            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.setAttribute(
                "download",
                `TransactionData_${new Date().toISOString().slice(0, 10)}.csv`
            );
            link.click();
        }
    },
};
</script>
  
  
<style scoped>
/* --- NEW STYLES FOR PASSWORD POPUP --- */
.password-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1050; /* Above other content */
}

.password-modal {
    background: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    width: 100%;
    max-width: 400px;
    text-align: center;
}

.text-danger {
    color: #dc3545;
}

.custom-explore {
    /* Assuming this class defines the blue button color */
    background-color: #2563eb; 
    border-color: #2563eb;
    color: white;
}

.btn-block {
    display: block;
    width: 100%;
}
/* -------------------------------------- */

@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap");

/* Existing styles below */
.header-title {
    font-weight: 600;
}

.custom-badge-success {
    background-color: #d1fae5;
    color: #059669;
    padding: 4px 10px;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
}

.custom-badge-danger {
    background-color: #ffe4e6;
    color: #e11d48;
    padding: 4px 10px;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 600;
    display: inline-block;
}

.custom-border-danger {
    background-color: transparent !important;
    border: 1px solid #e11d48 !important;
    padding: 5px 10px;
    border-radius: 5px;
}

.custom-btn-navy {
    background-color: #0d47a1;
    color: white;
}

.custom-16px-600 {
    font-size: 16px;
    font-weight: 600;
}

</style>